import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { IAssociated } from "app/models/core/lab/associated";
import { SharedService } from "app/services/core/shared.service";
import { LabService } from "app/services/lab/lab.service";



@Component({
  selector: 'app-multiple',
  templateUrl: './multiple.component.html',
  styleUrls: ['./multiple.component.scss']
})

export class MultipleComponent implements OnInit {

  list: IAssociated[] = [];

  displayedColumns: string[] = ['labName', 'address', 'city', 'state', 'zip', 'comments'];

  multipleList: IAssociated[] = [];
  selectedMultiple: IAssociated;
  dataSource = new MatTableDataSource<IAssociated>(this.list);

  listFilter = '';

  editMode = 'list';
  inputComments = '';
  inputLab: IAssociated;
  search = '';
  selected = '';
  inputLabName = '';
  inputAddress = '';
  inputCity = '';
  inputState = '';
  inputZip = '';

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;


  constructor(public labService: LabService,
    public sharedService: SharedService) { };

  ngOnInit() {
    if (this.labService.lab != null) {
      this.setupTable();
    }
  }

  refreshAssociated() {
    if (this.labService.lab != null) {

      this.labService.getAssociatedLab(this.labService.lab.stateNumber).subscribe(
        assoc => {
          this.labService.associated = assoc;
          this.setupTable();
          this.editMode = 'list';
        },
        error => console.log('error', error),
        () => {
        }
      );
    }
  }

  setupTable() {
    this.list = this.labService.associated.multipleList;
    this.dataSource.data = this.list;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  add() {
    this.editMode = 'add';
    this.inputLab = {
      labId: 0,
      labName: '',
      parentId: 0,
      cliaNumber: '',
      director: '',
      comments: '',
      hstLabId: 0,
      dateCreated: '',
      createdBy: '',
      lastUpdated: '',
      updatedby: '',
      parentFound: false,
      edit: false,
      labType: '',
      newAssociatedLabId: 0,
      associatedLookupDictResults: false,
      associatedLookupDict: null,
      hstId: 0,
      soaId: 0,
      stateNumber: '',
      sharedId: 0,
      taxId: '',
      multipleId: 0,
      address: '',
      city: '',
      state: '',
      zip: ''
    }
  }

  save() {
    if (this.inputLab != null) {
      if (this.editMode == 'add') {
        this.inputLab.newAssociatedLabId = this.inputLab.labId;
        this.inputLab.labName = this.inputLabName;
        this.inputLab.address = this.inputAddress;
        this.inputLab.city = this.inputCity;
        this.inputLab.state = this.inputState;
        this.inputLab.zip = this.inputZip;
      }
      this.inputLab.labId = this.labService.lab.labId;
      this.inputLab.comments = this.inputComments;
      this.labService.saveAssociatedLab(this.inputLab, 'Multiple').subscribe(
        () => {
          this.refreshAssociated();
        },
        error => console.log('error: ', error),
        () => {
        }
      );
    }
  }

  cancel() {
    this.editMode = 'list';
    this.multipleList = [];
  }

  delete(): void {
    if (!confirm('Delete this record? Continue?')) {
      return;
    }

    this.labService.deleteAssociated(this.inputLab.multipleId, 'Multiple').subscribe(
      () => {
        this.refreshAssociated();
        this.clearSearch();
      },
      error => console.log('error: ', error),
      () => {
      }
    );

  }

  filterTable(evnt: Event) {
    this.listFilter = (evnt.target as HTMLInputElement).value;
    this.dataSource.filter = this.listFilter.trim().toLowerCase();
  }

  clearFilter() {
    this.listFilter = "";
    this.dataSource.filter = this.listFilter;
  }

  getPageSizeOptions(): number[] {
    if (this.dataSource.data.length > 20) {
      return [10, 20, this.dataSource.data.length];
    } else {
      return [10, 20];
    }
  }

  rowclick(row: IAssociated) {
    this.editMode = 'edit';
    this.inputLab = row;
    this.inputComments = row.comments;
    this.inputLabName = row.labName;
    this.inputAddress = row.address;
    this.inputCity = row.city
    this.inputState = row.state;
    this.inputZip = row.zip;
  }

  updateFields(value: IAssociated) {
    this.inputLab = value;
    this.inputAddress = value.address;
    this.inputCity = value.city
    this.inputState = value.state;
    this.inputZip = value.zip;
  }


  getSharedList() {
    if (this.search != null && this.search != '') {
      this.labService.getMultipleList(this.search).subscribe(
        res => {
          this.multipleList = res;
          this.editMode = 'add';
        },
        error => console.log('error', error),
        () => {
        }
      );
    }
  }

  clearSearch() {
    this.search = "";
    this.multipleList = [];
  }

}